module.exports = __webpack_public_path__ + "img/制御工学7_2.a3c510ea.png";